import { useState } from "react";
import { api } from "./api";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function ChangePassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [status, setStatus] = useState("");

  const username = sessionStorage.getItem("username");
  const navigate = useNavigate();

  const handleChange = async (e) => {
    e.preventDefault();
    setError("");
    setStatus("");

    if (!newPassword || !confirmPassword) return setError("Fill in both fields.");
    if (newPassword !== confirmPassword) return setError("Passwords do not match.");

    try {
      await api.post(`/change-password`, { username, newPassword });
      setStatus("Password changed. Redirecting...");
      setTimeout(() => navigate("/patients"), 1500);
    } catch (err) {
      console.error(err);
      setError("Failed to change password.");
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `radial-gradient(circle at top left, #A8A8A8, #8C8C8C, #85D3DE, #8DDFEB)`,
      }}
    >
      <div className="backdrop-blur-md bg-white/30 p-8 rounded-xl shadow-2xl w-full max-w-sm border border-white/50">
        <img
          src="/InfoMedi_logo.png"
          alt="InfoMedi Logo"
          className="w-50 mx-auto mb-6 drop-shadow-md"
        />
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Change Password
        </h2>

        {status && <div className="text-green-900 text-sm mb-3 text-center">{status}</div>}
        {error && <div className="text-red-900 text-sm mb-3 text-center">{error}</div>}

        <form onSubmit={handleChange}>
          <div className="relative mb-4">
            <input
              type={showNew ? "text" : "password"}
              placeholder="New Password"
              className="w-full p-3 border border-gray-300 rounded-lg pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <span
              className="absolute right-3 top-3 text-gray-600 cursor-pointer"
              onClick={() => setShowNew(!showNew)}
            >
              {showNew ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="relative mb-4">
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirm Password"
              className="w-full p-3 border border-gray-300 rounded-lg pr-10 focus:outline-none focus:ring-2 focus:ring-indigo-400"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <span
              className="absolute right-3 top-3 text-gray-600 cursor-pointer"
              onClick={() => setShowConfirm(!showConfirm)}
            >
              {showConfirm ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button
            type="submit"
            className="w-full py-3 mt-2 rounded-lg text-white font-semibold 
             bg-gradient-to-r from-gray-400 to-blue-800 
             hover:from-blue-600 hover:to-gray-700 
             transition-all duration-300 shadow-md"
          >
            Update Password
          </button>
        </form>
      </div>
    </div>
  );
}
